import React from 'react';
import './key-item-status.styles.scss';
import { STATUS_LIST } from '../../enums/key-status-list';

export default function KeyItemStatus({ status, className }) {

    return (
        <span className={`${className} status-indicator d-inline-block ${STATUS_LIST[status].class}`}></span>
    )
}